export function renderBoundary(map: google.maps.Map, boundaryValue: any): google.maps.Data {
  const boundaryLayer = new google.maps.Data({ map })

  boundaryLayer.addGeoJson(boundaryValue)

  boundaryLayer.setStyle({
    fillColor: '#3b82f6',
    fillOpacity: 0.05,
    strokeColor: '#3b82f6',
    strokeWeight: 2,
    strokeOpacity: 0.8
  })

  return boundaryLayer
}

export function fitMapToBoundary(map: google.maps.Map, boundaryLayer: google.maps.Data) {
  const bounds = new google.maps.LatLngBounds()

  boundaryLayer.forEach((feature) => {
    const geometry = feature.getGeometry()
    if (geometry) {
      geometry.forEachLatLng((latLng) => {
        bounds.extend(latLng)
      })
    }
  })

  map.fitBounds(bounds)
}
